module.exports = __webpack_public_path__ + "img/linare-landing-1.f744714b.jpg";